"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventEmitter = void 0;
const utils_1 = require("./utils");
const EventNames = {
    INITIALIZED: 'initialized',
    NEW_VARIABLES: 'newVariables',
    ERROR: 'error',
    VARIABLE_UPDATED: 'variableUpdated',
    FEATURE_UPDATED: 'featureUpdated',
    CONFIG_UPDATED: 'configUpdated',
    VARIABLE_EVALUATED: 'variableEvaluated',
};
const isInvalidEventKey = (key) => {
    return (!Object.values(EventNames).includes(key) &&
        !key.startsWith(EventNames.VARIABLE_UPDATED) &&
        !key.startsWith(EventNames.FEATURE_UPDATED) &&
        !key.startsWith(EventNames.NEW_VARIABLES) &&
        !key.startsWith(EventNames.VARIABLE_EVALUATED));
};
class EventEmitter {
    constructor() {
        this.handlers = {};
    }
    subscribe(key, handler) {
        (0, utils_1.checkParamType)('key', key, 'string');
        (0, utils_1.checkParamType)('handler', handler, 'function');
        if (isInvalidEventKey(key)) {
            throw new Error('Not a valid event to subscribe to');
        }
        if (!this.handlers[key]) {
            this.handlers[key] = [handler];
        }
        else {
            this.handlers[key].push(handler);
        }
    }
    unsubscribe(key, handler) {
        (0, utils_1.checkParamType)('key', key, 'string');
        if (isInvalidEventKey(key)) {
            return;
        }
        if (handler) {
            const handlerIndex = this.handlers[key].findIndex((h) => h === handler);
            this.handlers[key].splice(handlerIndex, 1);
        }
        else {
            this.handlers[key] = [];
        }
    }
    emit(key, ...args) {
        var _a;
        (0, utils_1.checkParamType)('key', key, 'string');
        (_a = this.handlers[key]) === null || _a === void 0 ? void 0 : _a.forEach((handler) => {
            new Promise((resolve) => {
                handler(...args);
                resolve(true);
            });
        });
    }
    emitInitialized(success) {
        this.emit(EventNames.INITIALIZED, success);
    }
    emitError(error) {
        this.emit(EventNames.ERROR, error);
    }
    emitConfigUpdate(newVariableSet) {
        this.emit(EventNames.CONFIG_UPDATED, newVariableSet);
    }
    emitVariableEvaluated(variable) {
        this.emit(`${EventNames.VARIABLE_EVALUATED}:*`, variable.key, variable);
        this.emit(`${EventNames.VARIABLE_EVALUATED}:${variable.key}`, variable.key, variable);
    }
    emitVariableUpdates(oldVariableSet, newVariableSet, variableDefaultMap) {
        const keys = new Set(Object.keys(oldVariableSet).concat(Object.keys(newVariableSet)));
        let newVariables = false;
        keys.forEach((key) => {
            const oldVariableValue = oldVariableSet[key] && oldVariableSet[key].value;
            const newVariable = newVariableSet[key];
            const newVariableValue = newVariable && newVariableSet[key].value;
            if (JSON.stringify(oldVariableValue) !==
                JSON.stringify(newVariableValue)) {
                const variables = variableDefaultMap[key] &&
                    Object.values(variableDefaultMap[key]);
                if (variables) {
                    newVariables = true;
                    variables.forEach((variable) => {
                        var _a;
                        variable.value =
                            newVariableValue !== null && newVariableValue !== void 0 ? newVariableValue : variable.defaultValue;
                        variable.isDefaulted =
                            newVariableValue === undefined ||
                                newVariableValue === null;
                        (_a = variable.callback) === null || _a === void 0 ? void 0 : _a.call(variable, variable.value);
                    });
                }
                const finalVariable = newVariable || null;
                this.emit(`${EventNames.VARIABLE_UPDATED}:*`, key, finalVariable);
                this.emit(`${EventNames.VARIABLE_UPDATED}:${key}`, key, finalVariable);
            }
        });
        if (newVariables) {
            this.emit(`${EventNames.NEW_VARIABLES}`);
        }
    }
    emitFeatureUpdates(oldFeatureSet, newFeatureSet) {
        const keys = Object.keys(oldFeatureSet).concat(Object.keys(newFeatureSet));
        keys.forEach((key) => {
            const oldFeatureVariation = oldFeatureSet[key] && oldFeatureSet[key]._variation;
            const newFeature = newFeatureSet[key];
            const newFeatureVariation = newFeature && newFeatureSet[key]._variation;
            const finalFeature = newFeature || null;
            if (oldFeatureVariation !== newFeatureVariation) {
                this.emit(`${EventNames.FEATURE_UPDATED}:*`, key, finalFeature);
                this.emit(`${EventNames.FEATURE_UPDATED}:${key}`, key, finalFeature);
            }
        });
    }
}
exports.EventEmitter = EventEmitter;
//# sourceMappingURL=EventEmitter.js.map